import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { Client } from '@microsoft/microsoft-graph-client';

@Injectable({
  providedIn: 'root'
})

export class CustomLayoutService {
  saveLayout(layoutType: string, layout: string) {
    const currentLayout = localStorage.getItem(layoutType);
    if (currentLayout) {
      localStorage.removeItem(layoutType);
      localStorage.setItem(layoutType, layout);
    }
    else {
      localStorage.setItem(layoutType, layout);
    }
  }

  getLayout(layoutType: string): string | null {
    return localStorage.getItem(layoutType);
  };
}
